import addIcon from '@/assets/icons/added.svg';
import AdminIcon from '@/assets/icons/Admin.svg';
import archiveIcon from '@/assets/icons/archived.svg';
import arrow from '@/assets/icons/arrow.svg';
import checkIcon from '@/assets/icons/Check.svg';
import DashboardIcon from '@/assets/icons/Dashboard.svg';
import downloadFile from '@/assets/icons/download.svg';
import editIcon from '@/assets/icons/edit.svg';
import fraudIcon from '@/assets/icons/fraud.svg';
import historyIcon from '@/assets/icons/history.svg';
import importIcon from '@/assets/icons/Import.svg';
import inactiveIcon from '@/assets/icons/inactive.svg';
import lockIcon from '@/assets/icons/lock.svg';
import LoginIcon from '@/assets/icons/Login.svg';
import NewsIcon from '@/assets/icons/News.svg';
import NotificationIcon from '@/assets/icons/Notification.svg';
import rejectedIcon from '@/assets/icons/rejected.svg';
import ResetIcon from '@/assets/icons/Reset-Icon.svg';
import riskIcon from '@/assets/icons/risk.svg';
import SaveIcon from '@/assets/icons/Save.svg';
import SearchIcon from '@/assets/icons/Search.svg';
import SettingsIcon from '@/assets/icons/Settings.svg';
import terrorismIcon from '@/assets/icons/terrorism.svg';
import traitementIcon from '@/assets/icons/traitement.svg';
import updateIcon from '@/assets/icons/Update.svg';
import WalletIcon from '@/assets/icons/Wallet.svg';
import icon1 from '@/assets/landing/icons/1.svg';
import icon2 from '@/assets/landing/icons/2.svg';
import icon3 from '@/assets/landing/icons/3.svg';
import logo from '@/assets/Logo.svg';

export default {
  AppLogo: logo,
  IconImport: importIcon,
  IconNews: NewsIcon,
  IconLogin: LoginIcon,
  IconDocument: DashboardIcon,
  IconWallet: WalletIcon,
  IconSettings: SettingsIcon,
  IconNotification: NotificationIcon,
  IconSave: SaveIcon,
  IconAdmin: AdminIcon,
  IconSearch: SearchIcon,
  IconCheck: checkIcon,
  IconUpdate: updateIcon,
  IconHistory: historyIcon,
  IconEdit: editIcon,
  IconAdd: addIcon,
  IconArchive: archiveIcon,
  IconRejected: rejectedIcon,
  IconLock: lockIcon,
  IconInactive: inactiveIcon,
  IconTraitement: traitementIcon,
  IconArrow: arrow,

  IconTerrorism: terrorismIcon,
  IconFraud: fraudIcon,
  IconRisk: riskIcon,

  ResetIcon: ResetIcon,

  Icon1: icon1,
  Icon2: icon2,
  Icon3: icon3,

  IconDownloadTutorial: downloadFile,
};
